
import TrainIcon from '@mui/icons-material/Train';
import TuneIcon from '@mui/icons-material/Tune';
import AddIcon from '@mui/icons-material/Add';
import HomeIcon from '@mui/icons-material/Home';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import NotificationsIcon from '@mui/icons-material/Notifications';
import PlaceIcon from '@mui/icons-material/Place';
const dashboardNav = [
 
  {
    path: "/dashboard",
    name: "Dashboard",
    icon:<HomeIcon/>
  },
  {
    name: "Locomotive",
    icon: <TuneIcon />,
    subMenu: [
      {
        path: "/add-locomotive",
        name: "Add Locomotive",
        icon: <AddIcon />,
      },
      {
        path: "/locomotive-list",
        name: "Locomotive List",
        icon:<FormatListBulletedIcon/>
      },
      {
        path: "/locomotive",
        name: "Allocation",
        icon:<AddIcon/>
      },
      {
        path: "/allocation-list",
        name: "Allocation List",
        icon: <FormatListBulletedIcon />,
      },
    ],
  },
  {
    name: "Trains",
    icon: <TrainIcon />,
    subMenu: [
      {
        path: "/add-train",
        name: "Add Train",
        icon:<AddIcon/>
      },
      
      {
        path: "/train-list",
        name: "Train list",
        icon:<FormatListBulletedIcon/>
      },
      {
        path: "/live-trains",
        name: "Live Trains",
        icon:<FormatListBulletedIcon/>
      },
    ],
  },
  {
    name: "Trains Routes",
    icon: <TrainIcon />,
    subMenu: [
      {
        path: "/train-route",
        name: "Train Route List",
        icon:<FormatListBulletedIcon/>
      },
    
      
      {
        path: "/addtrain-route",
        name: "Add Train Route",
        icon:<AddIcon/>
      },
     
    ],
  },
  {
    name: "Stations",
    icon: <PlaceIcon />,
    subMenu: [
      {
        path: "/add-station",
        name: "Add Station",
        icon: <AddIcon />,
      },
      {
        path: "/station-list",
        name: "Station List",
        icon: <FormatListBulletedIcon />,
      },
    ],
  },
  {
    name: "Notification",
    icon: <NotificationsIcon />,
    subMenu: [
      {
        path: "/notification",
        name: "Notification List",
        icon:<FormatListBulletedIcon/>
      },
    
      
      {
        path: "/create-notification",
        name: "Add Notification",
        icon:<AddIcon/>
      },
     
    ],
  },
  
  
 
  // {
  //   path: "/promotions",
  //   name: "Promotions"
  // },
  // {
  //   path: "/analytics-reporting",
  //   name: "Analytics & Reporting"
  // },
  // {
  //   path: "/ticket-management",
  //   name: "Ticket Management"
  // },
  // {
  //   path: "/orders-management",
  //   name: "Orders Management"
  // },
];

export default dashboardNav;